import { useFormContext } from 'react-hook-form';
import { useSnapshot } from 'valtio/react';

import { Button } from '@paid-ui/components/button';
import { FormControl, FormField, FormHelper, FormItem } from '@paid-ui/components/form';
import { RadioGroup, RadioGroupCard } from '@paid-ui/components/radio-group';
import { Tooltip } from '@paid-ui/components/tooltip';

import { businessStructureOptions } from '../../constants/business';
import { signUpManager } from '../../models';
import { SignUpStep } from '../../models/enums';

interface Props {
  disabled?: boolean;
  goToStep?: (step: SignUpStep) => void;
}

export const StepBusinessStructure: React.FC<Props> = ({ disabled, goToStep }) => {
  const form = useFormContext();
  const { currentStep } = useSnapshot(signUpManager);

  const structure = form.watch('structure');
  const isValid = Boolean(structure);

  const handleNext = () => {
    goToStep?.(SignUpStep.BUSINESS_ABN);
  };

  if (currentStep !== SignUpStep.BUSINESS_STRUCTURE) {
    return null;
  }

  return (
    <div className="space-y-9">
      <FormField
        name="structure"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <RadioGroup
                {...field}
                onValueChange={(value) =>
                  form.setValue('structure', value, {
                    shouldValidate: true,
                  })
                }
                disabled={disabled}
                className="space-y-3.5"
              >
                {businessStructureOptions.map((option) => (
                  <Tooltip key={option.value} title={option.tooltip}>
                    <div>
                      <RadioGroupCard value={option.value}>{option.label}</RadioGroupCard>
                    </div>
                  </Tooltip>
                ))}
              </RadioGroup>
            </FormControl>
            <FormHelper />
          </FormItem>
        )}
      />
      <Button
        variant="solid"
        disabled={disabled || !isValid}
        className="h-[44px]"
        onClick={handleNext}
      >
        Continue
      </Button>
    </div>
  );
};
